@use '@/scss/underscore' as _;

.containsTableLayout {
  height: 100%;
}
